@if (store?.data; as storeData) {
<div class="flex flex-top">
    <p class="col-1 flex-grow h1-s h1-m h3">{{storeData.store_name}}</p>
    <!-- close button -->
    <span [lineHeightBy]="'h3'">
        <i class="icon-close cursor-pointer"
           (click)="close()"
           aria-hidden="true"></i>
    </span>
</div>
<page-store-finder-store-status class="m-t-5 block"
                                [store]="store"></page-store-finder-store-status>
<div class="m-t-5">
    <div class="c-6-set m-b-0">
        <p class="p1 col-1">{{storeData.address}},</p>
        <p class="p1 col-1 m-t-1">{{storeData.city}}, {{storeData.postcode}}</p>
    </div>
    <div class="c-6-set m-b-0">
        <a class="m-l-7 block p1 "
           [attr.href]="'tel:' + storeData.phone">
            <icon-label [icon]="'phone'"
                        [textClass]="'p1'">{{storeData.phone}}</icon-label>
        </a>
        <href [link]="storeData.directions">
            <icon-label [icon]="'location'"
                        [textClass]="'p1'"
                        class="m-t-1">Get Directions</icon-label>
        </href>
    </div>
</div>
<div class="m-t-10 p-t-10 b-t b-col-5">
    @for (day of storeData.openingHours | slice:0:7; track day; let first = $first) {
    <div class="flex flex-justify-between"
         [class.m-t-2]="!first">
        <p class="s1 col-1">{{day.date | date :'EEEE, MMM d'}}</p>
        <p class="p1 col-11">{{getOpeningHours(day)}}</p>
    </div>
    }
</div>
@if (storeData.tags?.length) {
<div class="m-t-10 p-t-10 b-t b-col-5 ">
    <p class="s1">{{'Features'|translate}}</p>
    <ul class="m-t-2 _features">
        @for (tag of storeData.tags; track tag) {
        <li class="m-t-2 p1 _feature">
            {{tag.tag_name}}
        </li>
        }
    </ul>
</div>
}
}